import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import logo from './logo.svg';
import './App.css';
import Home from './Views/Home';
import Subscriptions from './Views/Subscriptions';
import Products from './Views/Products';
import Customers from './Views/Customers';
import SuccessfullPayment from './Views/SuccessfullPayment';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/subscriptions/:token" element={<Subscriptions />} />
        <Route path="/corelife/products/:token" element={<Products />} />
        <Route path="/customers" element={<Customers />} />
				<Route path="/success" element={<SuccessfullPayment />} />
      </Routes>
    </Router>
  );
}

export default App;
